// extracted by mini-css-extract-plugin
export default {"root":"QualitySelector_root__t6rSe"};